<div class="todo-application">
  <div class="container-xxl p-0">
    <div class="content-body">
      <app-content-header [contentHeader]="contentHeader"></app-content-header>
    </div>
  </div>
  <div class="content-area-wrapper container-xxl p-0" [ngClass.sm]="'d-flex flex-column'">
    <div class="todo-sidebar-main" *ngIf="_utilsService.isDesktop">
      <div class="main-sidebar sidebar">
        <div class="sidebar-content todo-sidebar" [ngClass.sm]="'w-100'">
          <div class="todo-app-menu ps">
            <div class="add-task">
              <button type="button" rippleEffect class="btn btn-outline-primary btn-block" (click)="openedAddModal = true">{{ "ADD_TASK" | translate }}</button>
            </div>
            <div class="sidebar-menu-list" [ngClass.xl]="'mt-2'" [ngClass.sm]="'mb-2'">
              <div class="list-group list-group-filters mb-md-2" *ngIf="filter">
                <a class="list-group-item list-group-item-action" (click)="filter = 'all'; filterTask()" [ngClass]="{'active' : filter === 'all'}">
                  <i [data-feather]="'mail'" size="18" class="mr-75"></i>
                  <span class="align-middle">{{ "RECIEVED_PLURAL" | translate }}</span>
                </a>
                <a class="list-group-item list-group-item-action" (click)="filter = 'i_assigned'; filterTask()" [ngClass]="{'active' : filter === 'i_assigned'}">
                  <i [data-feather]="'send'" size="18" class="mr-75"></i>
                  <span class="align-middle">{{ "SENDED_PLURAL" | translate }}</span>
                </a>
              </div>

              <div class="px-1 my-2">
                <label for="filter_status">{{ "FILTER_STATUS" | translate }}</label>
                <ng-select id="filter_status" [clearable]="true" [placeholder]="'SELECT_STATUS' | translate" [(ngModel)]="filterStatus" (ngModelChange)="filterTask()" (clear)="filterStatus = undefined">
                  <ng-option [value]="0">{{ "STATUS.TODO" | translate }}</ng-option>
                  <ng-option [value]="1">{{ "STATUS.IN_PROGRESS" | translate }}</ng-option>
                  <ng-option [value]="2">{{ "STATUS.COMPLETED" | translate }}</ng-option>
                </ng-select>
              </div>

              <div class="px-1">
                <label for="filter_priority">{{ "FILTER_PRIORITY" | translate }}</label>
                <ng-select id="filter_priority" [clearable]="true" [placeholder]="'SELECT_PRIORITY' | translate" [(ngModel)]="filterPriority" (ngModelChange)="filterTask()" (clear)="filterStatus = undefined">
                  <ng-option [value]="0">{{ "LOW" | translate }}</ng-option>
                  <ng-option [value]="1">{{ "MEDIUM_SINGULAR_FEMALE" | translate }}</ng-option>
                  <ng-option [value]="2">{{ "HIGH" | translate }}</ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="todo-sidebar-main mb-0" *ngIf="_utilsService.isMobile || _utilsService.isTablet">
      <div class="card-body">
        <!--filtra per stato-->
        <div>
          <label for="filter_status_mobile">{{ "FILTER_STATUS" | translate }}</label>
          <ng-select id="filter_status_mobile" [clearable]="true" [placeholder]="'SELECT_STATUS' | translate" [(ngModel)]="filterStatus" (ngModelChange)="filterTask()" (clear)="filterStatus = undefined">
            <ng-option [value]="0">{{ "STATUS.TODO" | translate }}</ng-option>
            <ng-option [value]="1">{{ "STATUS.IN_PROGRESS" | translate }}</ng-option>
            <ng-option [value]="2">{{ "STATUS.COMPLETED" | translate }}</ng-option>
          </ng-select>
        </div>
        <!--filtra per priorità-->
        <div class="my-2">
          <label for="filter_priority_mobile">{{ "FILTER_PRIORITY" | translate }}</label>
          <ng-select id="filter_priority_mobile" [clearable]="true" [placeholder]="'SELECT_PRIORITY' | translate" [(ngModel)]="filterPriority" (ngModelChange)="filterTask()" (clear)="filterStatus = undefined">
            <ng-option [value]="0">{{ "LOW" | translate }}</ng-option>
            <ng-option [value]="1">{{ "MEDIUM_SINGULAR_FEMALE" | translate }}</ng-option>
            <ng-option [value]="2">{{ "HIGH" | translate }}</ng-option>
          </ng-select>
        </div>
        <!--bottoni-->
        <div class="d-flex">
          <a class="col-6 text-center" (click)="filter = 'all'; filterTask()" [ngClass]="filter === 'all' ? 'text-primary' : ''">
            <i [data-feather]="'mail'" size="18" class="mr-75"></i>
            <span class="align-middle">{{ "RECIEVED_PLURAL" | translate }}</span>
          </a>
          <a class="col-6 text-center" (click)="filter = 'i_assigned'; filterTask()" [ngClass]="filter === 'i_assigned' ? 'text-primary' : ''">
            <i [data-feather]="'send'" size="18" class="mr-75"></i>
            <span class="align-middle">{{ "SENDED_PLURAL" | translate }}</span>
          </a>
        </div>
        <!--aggiungi task-->
        <div class="w-100 mt-2">
          <button type="button" rippleEffect class="btn btn-outline-primary btn-block" (click)="openedAddModal = true">{{ "ADD_TASK" | translate }}</button>
        </div>
      </div>
    </div>
    <div class="content-right" [ngClass.sm]="'overflow-scroll'">
      <div class="content-wrapper">
        <div class="content-body">
          <div class="todo-app-list">
            <div class="app-fixed-search d-flex align-items-center" [ngClass.sm]="'border-top'">
              <div class="d-flex align-content-center justify-content-between w-100">
                <div class="input-group input-group-merge mt-05 mb-05">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i [data-feather]="'search'" size="18"></i>
                    </span>
                  </div>
                  <input type="text" id="todo-search" [placeholder]="'SEARCH_TASK' | translate" aria-label="Search..." [(ngModel)]="filterText" (ngModelChange)="filterTask()" class="form-control" />
                </div>
              </div>
            </div>
            <div class="todo-task-list-wrapper list-group pb-1" [perfectScrollbar]="config" #perfectScroll>
              <div *ngIf="!filtered_tasks || filtered_tasks.length < 1" class="px-2 py-1 font-small-4 font-weight-bold">{{ "NO_TASKS" | translate }}</div>
              <ul class="todo-task-list" *ngIf="filtered_tasks && filtered_tasks.length > 0">
                <li class="todo-item border-top" *ngFor="let task of filtered_tasks">
                  <div class="todo-title-wrapper">
                    <div class="todo-title-area" (click)="openTask(task.id)">
                      <div class="title-wrapper">
                        <div class="avatar-group" *ngIf="task.status !== 0">
                          <div placement="right" class="avatar pull-up" [ngbTooltip]="task.status === 1 ? ('IN_PROGRESS_FROM' | translate) + task.status_changer.complete_name : ('COMPLETED_FROM' | translate) + task.status_changer.complete_name">
                            <img #picture (error)="picture.hidden = true" [src]="task.status_changer.avatar" alt="Avatar" height="32" width="32" class="cover border-3-{{ task.status === 1 ? 'warning' : 'success' }}" />
                            <div *ngIf="task.status === 1 && task.status === 2 && picture.hidden" class="avatar-content text-uppercase">{{ task.status_changer.complete_name | initials }}</div>
                            <span></span>
                          </div>
                        </div>
                        <div class="avatar-group" *ngIf="task.status === 0">
                          <div class="avatar pull-up">
                            <div class="avatar bg-secondary avatar-md">
                              <div class="avatar-content">
                                <span [data-feather]="'user'" [class]="'avatar-icon'"></span>
                              </div>
                            </div>
                            <span></span>
                          </div>
                        </div>
                        <span class="todo-title mx-1">{{ task.title }}</span>
                      </div>
                    </div>
                    <div class="todo-item-action">
                      <small class="text-nowrap text-muted font-small-3 text-capitalize" [ngbTooltip]="'EXPIRE_DATE' | translate">{{ _utilsService.formatDate(task.end_date, "dddd DD MMM") }}</small>
                      <span class="ml-075" [ngbTooltip]="'SET_AS_COMPLETED' | translate" placement="left" (click)="setCompleted(task)" *ngIf="task.status === 0 || task.status === 1">
                        <i [data-feather]="'check'" size="20" class="text-success"></i>
                      </span>
                      <div class="mx-1">
                        <span [ngbTooltip]="'LOW_PRIORITY' | translate" placement="left" *ngIf="task.priority === 0">
                          <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
                        </span>
                        <span [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="left" *ngIf="task.priority === 1">
                          <i [data-feather]="'flag'" size="20" class="text-warning"></i>
                        </span>
                        <span [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="left" *ngIf="task.priority === 2">
                          <i [data-feather]="'flag'" size="20" class="text-danger"></i>
                        </span>
                      </div>
                      <div class="avatar-group" *ngIf="task.view_because === 'have_assigned'; else othersInformations">
                        <div class="avatar" *ngFor="let user of task.users">
                          <img #image (error)="image.hidden = true" [alt]="user.complete_name" height="30" width="30" class="cover" [src]="user.avatar" [ngbTooltip]="user.complete_name" placement="left" />
                          <div *ngIf="image.hidden" class="avatar-content text-uppercase">{{ user.complete_name | initials }}</div>
                        </div>
                      </div>
                      <ng-template #othersInformations>
                        <div [ngbTooltip]="'COMMENTS' | translate" placement="left" *ngIf="task.comment_number"><i [data-feather]="'message-square'" size="20" class="mr-025"></i> {{ task.comment_number }}</div>
                        <div [ngbTooltip]="'NO_COMMENTS' | translate" placement="left" *ngIf="!task.comment_number">
                          <i [data-feather]="'message-square'" size="20" class="mr-025"></i>
                        </div>
                        <div
                          [ngbTooltip]="task.attachment_number ? task.attachment_number + ' ' + ('ATTACHMENTS' | translate) : ('NO_ATTACHMENTS' | translate)"
                          placement="left"
                          class="ml-1"
                          [ngClass]="task.attachment_number ? 'text-primary' : ''"
                        >
                          <i [data-feather]="'link-2'" size="20" class="mr-025"></i>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-add-task *ngIf="openedAddModal" (callbackFn)="afterAddedTask()"></app-modal-add-task>
<app-modal-view-task *ngIf="openedTask !== 0" (callbackFn)="onCloseDetailModal()" [id]="openedTask"></app-modal-view-task>
